import React from 'react';
const Login = React.lazy(() => import('@views/login/'));
const Home = React.lazy(() => import('@views/home/'));
const Pswd = React.lazy(() => import('@views/pswd/'));

const routes = [
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/home',
    component: Home,
  },
  {
    path: '/pwsd',
    component: Pswd,
  },
  {
    path: '/ypshop',
    children: [
      {
        path: '/home',
        component: Home,
      },
    ],
  },
];
export default routes;
